import React, { useState } from 'react';

const VERSION = '0.3';
const CHANGELOG = [
  {
    version: '0.3',
    date: '2026-04-28',
    changes: [
      'New Print/Page Setup screen with paper size and duplex print mode selection',
      'Added Markup Options panel for output page numbers',
      'Interactive tutorial system with three guided phases',
      'Export booklet as a ZIP archive',
    ]
  },
  {
    version: '0.2',
    date: '2025-11-10',
    changes: [
      'Total UI overhaul for better usability',
      'Showing page thumbnails by default (disable in Debug Options)',
      'Added PDF Customization options, allowing scaling, offset, and rotation of pages',
    ]
  },
  {
    version: '0.1.5',
    date: '2024-11-26',
    changes: [
      'Added support for custom paper sizes',
      'Removed file size limit',
      'UI improvements',
      'Added donation request to download page',
    ]
  }
];

const VersionIndicator = () => {
  const [showChangelog, setShowChangelog] = useState(false);

  return (
    <div className="version-indicator">
      <span 
        className="version-number"
        onMouseEnter={() => setShowChangelog(true)}
        onMouseLeave={() => setShowChangelog(false)}
      >
        v{VERSION}
      </span>
      {showChangelog && (
        <div className="changelog-popup">
          {CHANGELOG.map(({ version, date, changes }) => (
            <div key={version} className="changelog-entry">
              <div className="changelog-header">
                <span className="changelog-version">v{version}</span>
                <span className="changelog-date">{date}</span>
              </div>
              <ul className="changelog-changes">
                {changes.map((change, index) => (
                  <li key={index}>{change}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VersionIndicator; 